import { AuthTimeoutService } from '@/common/auth/auth-timeout.service';
import { Component } from '@angular/core';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { RouterOutlet } from '@angular/router';
import { ToastModule } from 'primeng/toast';

@Component({
    selector: 'app-root',
    imports: [
        ConfirmDialogModule,
        ToastModule,
        RouterOutlet,
    ],
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss'
})
export class AppComponent {
	title: string = 'CrowdSync';
	constructor(private readonly authUserActivityService: AuthTimeoutService) {}
}
